
      import API from "!../../../node_modules/.pnpm/style-loader@3.3.2_webpack@5.74.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../node_modules/.pnpm/style-loader@3.3.2_webpack@5.74.0/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../node_modules/.pnpm/style-loader@3.3.2_webpack@5.74.0/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../node_modules/.pnpm/style-loader@3.3.2_webpack@5.74.0/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../node_modules/.pnpm/style-loader@3.3.2_webpack@5.74.0/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../node_modules/.pnpm/style-loader@3.3.2_webpack@5.74.0/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.74.0/node_modules/css-loader/dist/cjs.js!../../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.16+webpack@5.74.0/node_modules/postcss-loader/dist/cjs.js!../../../node_modules/.pnpm/svelte-loader@3.1.7_svelte@3.58.0/node_modules/svelte-loader/index.js?cssPath=/app/src/components/admin/ai-chat-widget.svelte.0.css!./ai-chat-widget.svelte";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.74.0/node_modules/css-loader/dist/cjs.js!../../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.16+webpack@5.74.0/node_modules/postcss-loader/dist/cjs.js!../../../node_modules/.pnpm/svelte-loader@3.1.7_svelte@3.58.0/node_modules/svelte-loader/index.js?cssPath=/app/src/components/admin/ai-chat-widget.svelte.0.css!./ai-chat-widget.svelte";
       export default content && content.locals ? content.locals : undefined;
